import React, { useEffect } from "react";
import { useState } from "react";
// import "./scheduleQListActivity.css";
import PdfQTypeActivity from "../../On_going/Published/Published_Q_list/PublishQuestionType/PdfType/PdfQTypeActivity";
import { Popup } from "semantic-ui-react";
import axios from "../../../../axios";
import { Link, NavLink, useLocation } from "react-router-dom";
import CompletedASList from "../../On_going/Published/Published_Q_list/CompletedASList";

export default function ScheduleQListActivity() {
  const [click, setClick] = useState();

  //Added this state by Kuldeep
  const { state } = useLocation()
  const [scheduledData, setScheduledData] = useState({
    ScheduledActivitys: [],
    completeSList: [],
  });
  const { ScheduledActivitys, completeSList } = scheduledData;

  useEffect(() => {
    const getScheduledActivity = async () => {
      try {
        const res = await axios.get(
          `/api/v1/homework/activity/getById/${state.scheduledActivity_id}`
        );
        const completeSList = await axios.get(
          `/api/v1/homework/studentActivity/getByAcivityId/${state.scheduledActivity_id}?status=completed`
        );
        res &&
          completeSList &&
          setScheduledData({
            ScheduledActivitys: res.data.data,
            completeSList: completeSList.data.data,
          });
      } catch (error) { }
    };
    getScheduledActivity();
  }, []);

  const myList = [completeSList];
  const totalLength = myList
    .map((array) => array.length)
    .reduce((sum, length) => sum + length, 0);

  return ScheduledActivitys ? (
    <div>
      <div>
        <div className="d-flex align-items-center ">
          <Link to="/PublishedHomeworkActivity" className="link">
            <img src="/images/Back Arrow.svg" alt=""></img>
          </Link>
          <Link to="/PublishedHomeworkActivity" className="link">
            <span className="open_publish_path">
              &nbsp; {ScheduledActivitys?.status} &nbsp;
            </span>
          </Link>
          <span className="open_publish_path1">
            / {ScheduledActivitys?.name}
          </span>
        </div>
        {/* <span className="mt-1 publishsub_heading">
          {ScheduledActivitys?.name}
        </span> */}
        <div className=" me-4 d-flex align-items-center justify-content-between">
          <span className="mt-2 publishsub_heading">
            {ScheduledActivitys?.name}
          </span>
          <span className="Subject_PreReads">
            {ScheduledActivitys?.total_marks} Marks
          </span>
        </div>

        <div className="mt-1 me-3 d-flex align-items-center justify-content-between ">
          <div className="d-flex align-items-center">
            <span className="Subject_PreReads">
              {ScheduledActivitys?.subject_id?.name} &nbsp;| &nbsp;
            </span>
            <span className=" open_ststus_activity ">
              {ScheduledActivitys?.status}
            </span>
            <div className="mx-2 activity_status_box d-flex align-items-center">
              <img
                src="/images/status circle1.svg"
                alt=""
                className="first"
                onClick={() => {
                  setClick(true);
                }}
              />
              <img
                src="/images/status circle2.svg"
                alt=""
                className="second"
                onClick={() => {
                  setClick(true);
                }}
              />
              {click && (
                <Popup
                  on="click"
                  className="completed_list"
                  trigger={
                    <span className="nth_persons d-flex align-items-center justify-content-center">
                      +{totalLength}
                    </span>
                  }
                  content={
                    <CompletedASList
                      completeList={completeSList}
                      setClick={setClick}
                    />
                  }
                  position=" right "
                />
              )}
            </div>
          </div>
          <NavLink to={`/ScheduleEditActivity`} state={{ scheduledActivity_id: ScheduledActivitys?.id }}>
            <button className="Edit_Btn" type="button">
              Edit
            </button>
          </NavLink>
        </div>
        <div className="Published_Activity_text mt-4">
          {ScheduledActivitys?.description}
        </div>

        <div className="mt-4 me-3  pdf_container_activity">
          {ScheduledActivitys?.attachments?.length !== 0 &&
            ScheduledActivitys?.attachments?.map((attachments) => (
              <PdfQTypeActivity
                publishedAttachData={ScheduledActivitys}
                attachments={attachments}
              />
            ))}
        </div>
      </div>
      <div className="closebtnActivity me-3 d-flex justify-content-end">
        <Link to="/PublishedHomeworkActivity">
          <button className="btn  m-1 activity_publish_close_button">
            Close
          </button>
        </Link>
      </div>
    </div>
  ) : (
    <></>
  );
}
